import React from 'react';
// import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop:10,
        marginBottom: 10,
    },
    paper: {
        // padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },

    themeButtonOrange: {
        // padding: theme.spacing(2),
        textAlign: 'center',
        backgroundColor: 'orange',
    },
    themeButtonBlue: {
        textAlign: 'center',
        backgroundColor: 'blue',
        color: '#fff',
    },
}));

export default function SelectTheme(){

    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Grid container spacing={1}>
                <Grid item xs={1}>
                    <Button className={classes.themeButtonOrange} >Orange</Button>
                </Grid>
                <Grid item xs={1}>
                    <Button className={classes.themeButtonBlue} >Outra cor</Button>
                </Grid>
                {/*<Grid item xs={1}>*/}
                {/*    <Paper className={classes.paper}>xs=6</Paper>*/}
                {/*</Grid>*/}
                {/*<Grid item xs={1}>*/}
                {/*    <Paper className={classes.paper}>xs=3</Paper>*/}
                {/*</Grid>*/}
                {/*<Grid item xs={1}>*/}
                {/*    <Paper className={classes.paper}>xs=3</Paper>*/}
                {/*</Grid>*/}
                {/*<Grid item xs={1}>*/}
                {/*    <Paper className={classes.paper}>xs=3</Paper>*/}
                {/*</Grid>*/}
                {/*<Grid item xs={1}>*/}
                {/*    <Paper className={classes.paper}>xs=3</Paper>*/}
                {/*</Grid>*/}
            </Grid>
        </div>
    );
}